import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SiteHeaderComponent } from './site-header/site-header.component';
import { SiteFooterComponent } from './site-footer/site-footer.component';
import { SiteLayoutComponent } from './site-layout/site-layout.component';
import { RouterModule } from '@angular/router';
import { GeneralModule } from '../general/general.module';
import { CryptoPricesComponent } from './crypto-prices/crypto-prices.component';
import { BlogPostsComponent } from './blog-posts/blog-posts.component';
import { StartStepsComponent } from './start-steps/start-steps.component';
import { AffiliateRewardsComponent } from './affiliate-rewards/affiliate-rewards.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BitoasisFeaturesComponent } from './bitoasis-features/bitoasis-features.component';
import { CryptoListItemComponent } from './crypto-list-item/crypto-list-item.component';
import { CryptoPageDetailComponent } from './crypto-page-detail/crypto-page-detail.component';
import { PriceAlertModule } from '../price-alert/price-alert.module';
import { PageHeaderComponent } from './page-header/page-header.component';
import { NavigationModule } from '../navigation/navigation.module';

@NgModule({
  declarations: [
    SiteLayoutComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    CryptoPricesComponent,
    BlogPostsComponent,
    StartStepsComponent,
    AffiliateRewardsComponent,
    GetStartedComponent,
    BitoasisFeaturesComponent,
    CryptoListItemComponent,
    CryptoPageDetailComponent,
    PageHeaderComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    GeneralModule,
    PriceAlertModule,
    NavigationModule,
  ],
  exports: [
    SiteLayoutComponent,
    SiteHeaderComponent,
    SiteFooterComponent,
    CryptoPricesComponent,
    BlogPostsComponent,
    StartStepsComponent,
    AffiliateRewardsComponent,
    GetStartedComponent,
    BitoasisFeaturesComponent,
    CryptoPageDetailComponent,
    PageHeaderComponent
  ]
})
export class FrontComponentsModule { }
